export const staffTypes = {
  VERIFICATION: "staff_verification",
  CV: "staff_cv",
  JOBS: "staff_jobs",
  BLOG_CREATOR: "staff_blog_creator",
  BLOG_MODERATOR: "staff_blog_moderator",
  GUEST: "staff_guest",
  CHAT: "staff_chat_access",
  ADMIN_MANAGER: "staff_admin_manager",
};
